import { render, staticRenderFns } from "./CardTab.vue?vue&type=template&id=d1b6fc62&"
import script from "./CardTab.vue?vue&type=script&lang=js&"
export * from "./CardTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports